var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"twitter"),React.createElement("path",{"d":"M9.27,5.33V5.5A3.82,3.82,0,0,1,5.43,9.33a3.91,3.91,0,0,1-2.06-.6c.1,0,.2,0,.33,0A2.66,2.66,0,0,0,5.37,8.2,1.34,1.34,0,0,1,4.1,7.27c.07,0,.17,0,.27,0s.23,0,.36,0A1.37,1.37,0,0,1,3.67,5.93v0a1.23,1.23,0,0,0,.6.17,1.35,1.35,0,0,1-.6-1.14,1.49,1.49,0,0,1,.16-.66A4,4,0,0,0,6.6,5.67a1,1,0,0,1,0-.3A1.34,1.34,0,0,1,7.9,4a1.27,1.27,0,0,1,1,.44,2.67,2.67,0,0,0,.86-.34,1.32,1.32,0,0,1-.6.74,3.11,3.11,0,0,0,.77-.2A2.43,2.43,0,0,1,9.27,5.33Z","transform":"translate(-3.37 -4.03)","key":1})]);
}

Twitter.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 6.53 5.3"};

module.exports = Twitter;

Twitter.default = Twitter;
